export default __webpack_public_path__ + "static/media/bank_note.ae8439c6.png";